export default __webpack_public_path__ + "static/media/pnsv_stand_CocaCola.24e66f99.png";